import { ToastOptions } from "react-toastify";
const CONFIG_OPTION_TOAST_NORMAL: ToastOptions = { position: "top-right", hideProgressBar: true, className: 'bg-white text-muted', progress: undefined, toastId: "" };

const CONFIG_OPTION_TOAST_ERROR: ToastOptions  = { position: "top-right", hideProgressBar: true, className: 'bg-white text-danger', progress: undefined, toastId: "" };

const CONFIG_OPTION_TOAST_COPY: ToastOptions = { position: "bottom-left", hideProgressBar: true, className: 'bg-white text-muted', progress: undefined, toastId: "",  };

export { CONFIG_OPTION_TOAST_NORMAL,  CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_COPY}